export { default as CompanyProfileLineGraph } from "./component";
